export default __webpack_public_path__ + "static/media/S-logo.95c79f61.png";